// eslint-disable-next-line no-unused-vars
import * as nkc from '../services/nkc';
import { mulTimeDimensionMulIndexMulValue } from '@/utils/reportResponseUtil';
function sortArr(arr, prop, type) {
  arr.sort(function (a, b) {
    return type === 1 ? b[prop] - a[prop] : a[prop] - b[prop];
  });
}
export default {
  namespace: 'nkc',

  state: {},

  effects: {
    *getGlobalReport({ payload: { value } }, { call, put }) {
      const response = yield call(nkc.getGlobalReport, value);
      let data = [],
        city = [];
      if (response.data.length > 0) {
        const arr = response.data.map((item) => {
          return {
            city: item.values[0].value,
            [item.index]: item.values[1].value,
            SORT: item.values[2].value,
          };
        });
        for (let i = 0; i < arr.length; i++) {
          if (!city.includes(arr[i].city)) {
            data.push({
              city: arr[i].city,
              REGION_ACTUAL_NEW: arr[i].REGION_ACTUAL_NEW || null,
              REGION_PLAN_NEW: arr[i].REGION_PLAN_NEW || null,
              SORT: arr[i].SORT,
            });
            city.push(arr[i].city);
          } else {
            for (let j = 0; j < data.length; j++) {
              if (data[j].city === arr[i].city) {
                if (
                  !data[j].REGION_ACTUAL_NEW ||
                  data[j].REGION_ACTUAL_NEW === null
                ) {
                  data[j].REGION_ACTUAL_NEW = arr[i].REGION_ACTUAL_NEW;
                }
                if (
                  !data[j].REGION_PLAN_NEW ||
                  data[j].REGION_PLAN_NEW === null
                ) {
                  data[j].REGION_PLAN_NEW = arr[i].REGION_PLAN_NEW;
                }
              }
            }
          }
        }
      }
      sortArr(data, 'SORT');
      yield put({
        type: 'save',
        payload: {
          globalReport: data,
        },
      });
    },
    *getQueryWeeklyYtdReport({ payload: { value } }, { call, put }) {
      const response = yield call(nkc.getQueryWeeklyYtdReport, value);
      const initData = mulTimeDimensionMulIndexMulValue(response.data);
      const WEEKLY_PLAN_NEW_INIT = initData.ALL.WEEKLY_PLAN_NEW || [];
      const WEEKLY_ACTUAL_NEW_INIT = initData.ALL.WEEKLY_ACTUAL_NEW || [];
      const WEEKLY_ACTIVITY_NEW_INIT = initData.ALL.WEEKLY_ACTIVITY_NEW || [];
      let WEEKLY_PLAN_NEW = WEEKLY_PLAN_NEW_INIT.map((item) => ({
        name: item.LABEL,
        value: item.VALUE,
      }));
      let WEEKLY_ACTUAL_NEW = WEEKLY_ACTUAL_NEW_INIT.map((item) => ({
        name: item.LABEL,
        value: item.VALUE,
      }));
      let queryWeeklyYtdReportTime = '';
      let activeData = WEEKLY_ACTIVITY_NEW_INIT.map((item) => ({
        week: item.VALUE,
        name: item.LABEL,
      }));
      sortArr(WEEKLY_PLAN_NEW, 'name');
      sortArr(WEEKLY_ACTUAL_NEW, 'name');
      let WEEKLY_PLAN_NEW_DATA = WEEKLY_PLAN_NEW.map((item) => item.value);
      let WEEKLY_ACTUAL_NEW_DATA = WEEKLY_ACTUAL_NEW.map((item) => item.value);
      yield put({
        type: 'save',
        payload: {
          weeklyActualNew: WEEKLY_ACTUAL_NEW,
          weeklyPlanNew: WEEKLY_PLAN_NEW,
          weeklyActualNewData: WEEKLY_ACTUAL_NEW_DATA,
          weeklyPlanNewData: WEEKLY_PLAN_NEW_DATA,
          queryWeeklyYtdReportTime,
          activeData,
        },
      });
    },
    *getQueryReportDeadline({ payload: { value } }, { call, put }) {
      const response = yield call(nkc.getQueryReportDeadline, value);
      yield put({
        type: 'save',
        payload: {
          queryReportDeadlineDate: response.data.date,
        },
      });
    },
    *getQueryWeeklyReportByStore({ payload: { value } }, { call, put }) {
      const response = yield call(nkc.getQueryWeeklyReportByStore, value);
      const initData = response.data;
      const newData = initData.map((item) => {
        let m = 0;
        let y = 0;
        if (item.mtdPlan === 0) {
          m = 0;
        } else {
          m = (
            Math.round(
              ((item.mtdFinish - item.mtdPlan) / item.mtdPlan) * 100 * 100,
            ) / 100
          ).toFixed(2);
        }
        if (item.totalPlan === 0) {
          y = 0;
        } else {
          y = (
            Math.round(
              ((item.totalFinish - item.totalPlan) / item.totalPlan) *
                100 *
                100,
            ) / 100
          ).toFixed(2);
        }
        return { ...item, mPercentage: m, yPercentage: y };
      });
      yield put({
        type: 'save',
        payload: {
          queryWeeklyReportByStore: newData,
        },
      });
    },
    *sortQueryWeeklyReportByStore({ payload: { value } }, { put }) {
      yield put({
        type: 'save',
        payload: {
          queryWeeklyReportByStore: value.data,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {},
};
